import React, { useMemo } from 'react';
import {
  AttachmentResult,
  AttachmentType,
  SimulatorResultItem,
} from '@sdir/httpclient/lib/clients/aps/application';
import { QualificationType } from '../../../types/enums';
import { NewGroupAction } from './NewGroupAction';
import { ExistingGroupAction } from './ExistingGroupAction';

interface RequirementActionProps {
  applicationUid: string;
  requirement: SimulatorResultItem;
  groupedAttachments?: { [attachmentGroup: string]: AttachmentResult[] };
}

export const RequirementAction: React.FC<RequirementActionProps> = ({
  applicationUid,
  requirement,
  groupedAttachments,
}) => {
  const addableAttachmentType = useMemo(() => {
    if (requirement.status) return null;

    switch (requirement.type) {
      case QualificationType.SeagoingTime:
        return AttachmentType.SeagoingTime;
      case QualificationType.Education:
        return AttachmentType.Education;
      case QualificationType.Course:
        return AttachmentType.Course;
      default:
        return null;
    }
  }, [requirement.status, requirement.type]);

  const attachmentGroups = useMemo(
    () => (groupedAttachments ? Object.entries(groupedAttachments) : []),
    [groupedAttachments]
  );

  if (!addableAttachmentType && !attachmentGroups.length) return null;

  return (
    <>
      {addableAttachmentType && !attachmentGroups.length && (
        <NewGroupAction type={addableAttachmentType} requirement={requirement} />
      )}
      {attachmentGroups.map(([group, attachments]) => (
        <ExistingGroupAction
          key={group}
          applicationUid={applicationUid}
          type={attachments[0]?.type || AttachmentType.Na}
          attachmentGroup={group}
          attachments={attachments}
        />
      ))}
    </>
  );
};
